import React, { useState } from "react";
import { BookingButtonProps } from "./BookingButtonProps";
import { LabelsProvider } from "./LabelsContext/LabelsContext";
import { BookingProvider } from "./BookingContext/BookingContext";
import { BookingModalDecision } from "./BookingModalDecision";
import { VolvatOptimizelyProvider } from "../Optimizely/VolvatOptimizelyProvider";

interface ExtendedBookingButtonProps extends BookingButtonProps {
  awaitTime?: string;
  labelCssClass?: string;
  descriptionCssClass?: string;
  ignorePersistedData?: boolean;
}

export const BookingButton: React.FC<ExtendedBookingButtonProps> = ({
  bookingButton,
  cssClass,
  labelCssClass,
  descriptionCssClass,
  waitlist,
  awaitTime,
  ignorePersistedData,
}) => {
  const [isModalOpened, setIsModalOpened] = useState(false);

  const closeModal = () => setIsModalOpened(false);
  const openModal = () => setIsModalOpened(true);

  return (
    <>
      {bookingButton.targetUrl ? (
        <a className={cssClass} href={bookingButton.targetUrl}>
          <span className={labelCssClass}>{bookingButton.label}</span>
        </a>
      ) : (
        <LabelsProvider bookingLabels={bookingButton.bookingLabels}>
          <BookingProvider
            dipsAutoQueryMaxRepeats={bookingButton.dipsAutoQueryMaxRepeats}
            requireParentSsn={bookingButton.requireParentSsn}
            filterValues={bookingButton.filterValues}
            newBookingFilterValues={bookingButton.newBookingFilterValues}
            awaitTime={awaitTime}
            waitlist={waitlist}
            blockedSsnErrorMessage={bookingButton.blockedSsnErrorMessage}
            blockedSsnList={bookingButton.blockedSsnList}
            optimizelyExperimentation={bookingButton.optimizelyExperimentation}
            trackAbEvent={bookingButton.trackAbEvent}
          >
            <button className={cssClass} onClick={openModal}>
              <div className={labelCssClass}>{bookingButton.label}</div>
              {!!bookingButton.description && (
                <div className={descriptionCssClass}>
                  {bookingButton.description}
                </div>
              )}
            </button>
            <VolvatOptimizelyProvider
              sdkKey={bookingButton.optimizelyExperimentation?.sdkKey}
            >
              <BookingModalDecision
                bookingButton={bookingButton}
                closeModal={closeModal}
                isModalOpened={isModalOpened}
                ignorePersistedData={ignorePersistedData}
              />
            </VolvatOptimizelyProvider>
          </BookingProvider>
        </LabelsProvider>
      )}
    </>
  );
};
